// extracted by mini-css-extract-plugin
export var title = "pkaTTKIs";